var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04682 12.3252C5.67257 12.3252 3.74747 10.3885 3.74747 8.00027C3.74747 5.61083 5.67257 3.67472 8.04682 3.67472C10.4217 3.67472 12.3462 5.61083 12.3462 8.00027V8.00087C12.3462 10.3897 10.4217 12.3252 8.04682 12.3252ZM8.04682 0.000560858C3.6562 -0.0512133 0.0540029 3.48809 0.000561386 7.90575C-0.0510788 12.3234 3.46646 15.947 7.85827 16H8.04742C9.61589 16.0035 11.1488 15.5318 12.4452 14.6466V15.782H16V8.00147C15.9964 3.58442 12.438 0.00417301 8.04682 0.00116288",
    fill: "#6BC4E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcima);
export default __webpack_public_path__ + "static/media/acima.f7781d28cca65985b4ed6b2fab2d33f4.svg";
export { ForwardRef as ReactComponent };